export const invokeInlineLifecycleCallback = (label: string, invoke: () => unknown): void => {
  try {
    void Promise.resolve(invoke()).catch((error) => {
      console.error(`Clickterm inline ${label} callback failed.`, error);
    });
  } catch (error) {
    console.error(`Clickterm inline ${label} callback failed.`, error);
  }
};
